module.exports = __webpack_public_path__ + "img/icon-salary.839294bf.png";